<template>
  <div v-loading="loading">
    <el-form :model="formData" ref="formData" :rules="rulesAdd" label-width="120px" label-position="right" size="small"
             style="margin-right: 3vw">
      <el-row>
        <el-col :span="12">
          <el-form-item label="办事处名称：" prop="office_name" label-width="120px" style="height: 50%">
            <el-input v-model="formData.office_name" placeholder="请输入办事处名称"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="联系人：" prop="link_man" label-width="120px" style="height: 50%">
            <el-input v-model="formData.link_man" placeholder="请输入联系人姓名"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="联系电话：" prop="link_phone" label-width="120px" style="height: 50%">
            <el-input v-model="formData.link_phone" placeholder="请输入联系电话"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="地址：" prop="address" label-width="120px" style="height: 50%">
            <el-input v-model="formData.address" placeholder="请输入办事处地址"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="排序：" prop="sort" label-width="120px" style="height: 50%">
            <el-input-number v-model="formData.sort" controls-position="right" :min="0" :max="100000000" ></el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="备注：" prop="confirmRemark">
            <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="formData.remark" maxlength="100" show-word-limit="true"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <div style="text-align:center;">
      <el-button type="primary" @click="addOrUpdate" size="small">保存</el-button>
    </div>
  </div>
</template>
<script>
import Xheditor from "@/components/XhComponents/XhEditor";
import AttachmentList from "@/components/AttachmentList";
import AttachmentUpload from "@/components/AttachmentUpload";

export default {
  name: "HistoryEdit",
  props: ["data", "title"],
  components: {Xheditor, AttachmentList, AttachmentUpload},
  data() {
    return {
      formData: this.data,
      rulesAdd: {
        office_name: [{required: true, message: "必填项", trigger: "blur"}],
        link_man: [{required: true, message: "必填项", trigger: "blur"}],
        link_phone: [
          {required: true,message: "必填项", trigger: "blur"},
          {
            pattern:/(^1(3[0-9]|4[01456879]|5[0-35-9]|6[2567]|7[0-8]|8[0-9]|9[0-35-9])\d{8})|(^(0\d{2,3})-?(\d{7,8}))$/,
            message: "电话号码格式错误",
            rigger: "blur",
          }
        ],
        address: [{required: true, message: "必填项", trigger: "blur"}],
        sort: [{required: true, message: "必填项", trigger: "blur"}],
      },
      loading: false,
      fileID: this.data.id,
    }
  },
  methods: {
    addOrUpdate() {
      let that = this;
      this.$refs.formData.validate((valid) => {
        if (valid) {
          that.$api.post("/AfterSalesOffice/saveData", that.formData,
              function (res) {
                if (res.code === "200" && res.msg === "true") {
                  that.$emit("closeModal");
                  that.$message.success("保存成功");
                } else {
                  that.$message.warning("保存失败");
                }
              },
          );
        } else {
          return false;
        }
      });
    },
    afterload() {
      this.loading = false;
    },
    getAttachList(id) {
      this.$refs["fileList" + id].GetAttachmentList();
    },
    change(val) {
      var that = this;
      that.formData.about_content = val;
    },
  },
  mounted() {
  },
  created() {
  },
  watch: {
    data: function () {
      this.formData = this.data;
    },
  }
}
</script>
<style scoped lang="less">

</style>
